import { Context } from '@nuxt/types'

const FF_TESTING_COOKIE = 'ff_testing_id'

export const getTestingIdCookie = (context: Context): string | undefined => context.$cookies.get(FF_TESTING_COOKIE)
export const setTestingIdCookie = (context: Context, id: string): void =>
  context.$cookies.set(FF_TESTING_COOKIE, id, { maxAge: 60 * 60 * 2, path: '/' })
